import { render, staticRenderFns } from "./AccountSettingAddress.vue?vue&type=template&id=40fff5d9&scoped=true&"
import script from "./AccountSettingAddress.vue?vue&type=script&lang=js&"
export * from "./AccountSettingAddress.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingAddress.vue?vue&type=style&index=0&id=40fff5d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fff5d9",
  null
  
)

export default component.exports